import { LoyaltyLevelEnum } from '../enum/LoyaltyLevelEnum';

export const LoyaltyLevelName: Record<LoyaltyLevelEnum, string> = {
    [LoyaltyLevelEnum.LEVEL0]: 'MYUTMB+',
    [LoyaltyLevelEnum.LEVEL1]: 'EXPLORER',
    [LoyaltyLevelEnum.LEVEL2]: 'TRAILBLAZER',
    [LoyaltyLevelEnum.LEVEL3]: 'SUMMITER',
};
